import { render } from "./somePie.vue?vue&type=template&id=5614fde5"
import script from "./somePie.vue?vue&type=script&lang=js"
export * from "./somePie.vue?vue&type=script&lang=js"

import "./somePie.vue?vue&type=style&index=0&id=5614fde5&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\乐伴伴10.9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__